import PropTypes from 'prop-types';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useWishlist from 'hooks/useWishlist';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';

import WISHLIST from 'constants/wishlist';

const FinishedOfferButtons = ({
  gaEventCategory,
  offerId,
  mostRelevantKeyword,
  utms,
  ...rest
}) => {
  const { addOfferWishlistKeyword } = useWishlist(gaEventCategory, {
    gaEventLabel: 'wishlist_main_button',
  });

  const onWishlistButtonClick = () => {
    addOfferWishlistKeyword({ keywordDisplay: mostRelevantKeyword });
  };

  const onOfferFinishedButtonClick = () =>
    sendEvent({ action: 'go_store', category: gaEventCategory });

  return (
    <Block full {...rest}>
      <Button
        type="primary"
        size="size1"
        aria-label="Lista de desejos"
        letterSpacing={[null, null, null, null, '-0.5px']}
        iconLeft={<Icon name="heart-filled" aria-hidden />}
        full
        onClick={onWishlistButtonClick}
      >
        {WISHLIST.OFFER.WHEN_FINISHED_TO_ADD_WISHLIST}
      </Button>
      <Button
        type="subtle"
        size="size1"
        target="_blank"
        as="a"
        iconRight={<Icon name="link-blank" />}
        href={toOfferRedirectLink(offerId, utms)}
        mt={2}
        full
        onClick={onOfferFinishedButtonClick}
      >
        Oferta encerrada
      </Button>
    </Block>
  );
};

FinishedOfferButtons.defaultProps = {
  utms: null,
  offerId: null,
};

FinishedOfferButtons.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerId: PropTypes.number,
  utms: PropTypes.string,
};

export default FinishedOfferButtons;
